export default "__VITE_ASSET__dc527c29__"